import * as angular from "angular";

const employmentTypes = [
  {
    title: 'Independent',
    value: 'Independent'
  },
  {
    title: 'Payroll',
    value: 'Payroll'
  }
];

angular
  .module('bringoz.admin.commons')
  .constant('employmentTypes', employmentTypes);
